module.exports = __webpack_public_path__ + "media/images/room_monitor/vacancy-3ac63412c024250f3d9cd5dea01c9157.gif";